import { render } from "./EditLocation.vue?vue&type=template&id=650cd58e&scoped=true&ts=true"
import script from "./EditLocation.vue?vue&type=script&lang=ts"
export * from "./EditLocation.vue?vue&type=script&lang=ts"

import "./EditLocation.vue?vue&type=style&index=0&id=650cd58e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650cd58e"]])

export default __exports__